import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Switch } from 'antd';
import classNames from 'classnames/bind';
import PERMISSIONS from 'config/app-permission.config';
import { Panel } from 'components/ui/index';
import { updateGerenalSettings } from '../flow/action';
import styles from '../index.less';

const cx = classNames.bind(styles);

const TaskOwnerSwitcher = ({
  taskOwnerEnable,
  updateGerenalSettings,
  permissions,
}) => {
  const handleSwitchChange = checked => {
    updateGerenalSettings({ open_tasks_owner_change: checked });
  };

  const checkPermission = () => permissions && !permissions.some(p => p === PERMISSIONS.SETUP_GENERALSETTINGS_OTHERSETTINGS_UPDATE);

  return (
    <Panel
      panelTitle={<FormattedMessage id="page.GeneralSettings.taskOwner" />}
    >
      <div className={classNames(cx('settings-taskOwner-content'), 'pr-xlg', 'pl-lg', 'pt-lg')}>
        <FormattedMessage id="page.GeneralSettings.taskOwnerDescription">
          {text => <span className={classNames(cx('taskOwner-content-description'))}>{text}</span>}
        </FormattedMessage>
        <Switch
          checked={taskOwnerEnable}
          disabled={checkPermission()}
          className={classNames(cx('taskOwner-switch'))}
          onClick={handleSwitchChange}
          checkedChildren={
            <FormattedMessage id="page.GeneralSettings.enable">
              {text => <div style={{ width: '50px' }}>{text}</div>}
            </FormattedMessage>
          }
          unCheckedChildren={
            <FormattedMessage id="page.GeneralSettings.disable">
              {text => <div style={{ width: '50px' }}>{text}</div>}
            </FormattedMessage>
          }
        />
      </div>
    </Panel>
  );
};

const mapStateToProps = ({ setup, global }) => ({
  lang: global.language,
  taskOwnerEnable: setup.generalSettings.settings.open_tasks_owner_change,
  permissions: global.permissions,
});

const mapDispatchToProps = {
  updateGerenalSettings
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskOwnerSwitcher);



// WEBPACK FOOTER //
// ./src/views/Setup/GeneralSettings/component/TaskOwnerSwitcher.jsx